import { Component, Input } from '@angular/core';
import { CommonModule, NgStyle } from '@angular/common';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule, NgStyle],
  template: `
    <div
      class="wrapper"
      style="display: none"
      [attr.id]="parent"
      (click)="dismiss($event)"
    >
      <section class="editor-modal" [ngStyle]="style">
        <ng-content select="modal-content"></ng-content>
      </section>
    </div>
  `,
  styles: [
    `
      .wrapper {
        position: fixed;
        inset: 0;
        z-index: 99999;
        display: grid;
        place-items: center;
        background-color: rgba(0, 0, 0, 0.15);
        backdrop-filter: blur(0.2rem);
        padding: 1rem;
        animation: blurUp 0.15s ease-in-out;
        font-family: 'Inter', sans-serif !important;
      }

      .editor-modal {
        max-width: 640px;
        max-height: 750px;
        width: 100%;
        padding: 1.1rem 1.45rem;
        background-color: white;
        border-radius: 0.3rem;
        border: 1px solid #ebecef;
        overflow: hidden;
      }

      @keyframes blurUp {
        0% {
          backdrop-filter: blur(0);
          transform: scale(1.3) translateY(-3rem);
          opacity: 0;
        }
        100% {
          backdrop-filter: blur(0.5rem);
          transform: scale(1) translateY(0);
          opacity: 1;
        }
      }
    `,
  ],
})
export class ModalComponent {
  @Input() style: { [key: string]: any } = {};
  @Input() parent: string;

  dismiss(event: MouseEvent) {
    const el = event.target as HTMLElement;

    if (!el.classList.contains('wrapper')) return;

    el.style.display = 'none';
  }
}
